
import CableTvComp from "../../components/calbelTv/CableTvComp"

export const CableTvPage = ({ title_1, title_2, title }) => {
   
    return <div>
        <CableTvComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}